module.exports = __webpack_public_path__ + "static/img/hn-bio.0236869.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/hn-bio.png
// module id = t5Wo
// module chunks = 1